module.exports = __webpack_public_path__ + "static/media/ginger.3bda38a9.png";